
// swtich for mini style NAV, realted to 'collapseNav' directive
export function toggleNavCollapsedMin($rootScope) {

    'ngInject';

    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, ele, attrs) {
        var app;

        app = $('#app');

        ele.on('click', function(e) {
            if (app.hasClass('nav-collapsed-min')) {
                app.removeClass('nav-collapsed-min');
            } else {
                app.addClass('nav-collapsed-min');
                $rootScope.$broadcast('nav:reset');
            }
            return e.preventDefault();
        });            
    }
}


// Add 'active' class to li based on url, muli-level supported, jquery free
export function highlightActive() {
    var directive = {
        restrict: 'A',
        controller: toggleNavCollapsedMinCtrl
    };

    return directive;

    function toggleNavCollapsedMinCtrl($scope, $element, $attrs, $location) {

        'ngInject';

        var highlightActive, links, path;

        links = $element.find('a');

        path = function() {
            return $location.path();
        };

        highlightActive = function(links, path) {
            path = '#' + path;
            return angular.forEach(links, function(link) {
                var $li, $link, href;
                $link = angular.element(link);
                $li = $link.parent('li');
                href = $link.attr('href');
                if ($li.hasClass('active')) {
                    $li.removeClass('active');
                }
                if (path.indexOf(href) === 0) {
                    return $li.addClass('active');
                }
            });
        };

        highlightActive(links, $location.path());

        $scope.$watch(path, function(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            return highlightActive(links, $location.path());
        });

    }

}

// toggle on-canvas for small screen, with CSS
export function toggleOffCanvas() {
    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, ele, attrs) {
        ele.on('click', function () {
            rootScope.showingSideNav = !rootScope.showingSideNav;
        });
    }
}

//Toggle the menu for content pages...not the nav menu
export function toggleMenuOffCanvas() {
    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, ele, attrs) {
    
        ele.on('click', function () {
            if ($('#app').hasClass("on-canvas-menu"))
                $('#app').removeClass("on-canvas-menu");
            else
                $('#app').addClass("on-canvas-menu");
        });
    }
}

//Toggle the menu for content pages...not the nav menu
export function toggleFiltersOffCanvas() {
    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, ele, attrs) {

        ele.on('click', function () {
            if ($('#app').hasClass("on-filters-menu")) {
                $('#app').removeClass("on-filters-menu");
            } else {
                $('#app').addClass("on-filters-menu");
            }
        });
    }
}


// toggle on-canvas for small screen, with CSS
export function toggleUserMenu() {
    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, ele, attrs) {
        ele.on('click', function () {
            if ($('.g-profile-menu').hasClass("show")) {
                return $('.g-profile-menu').removeClass("show");
            } else {
                return $('.g-profile-menu').addClass("show");
            }
        });
    }
}

//hide the user profile menu when it is navigated away from
export function hideUserMenu() {
    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, ele, attrs) {
        ele.on('blur', function () {
            if ($('.g-profile-menu').hasClass("show")) {
                setTimeout(() => $('.g-profile-menu').removeClass("show"), 200);
            }
        });
    }
}

export function toggleCollapseableUserMenu() {
    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, ele, attrs) {
        ele.on('click', function () {
            if ($('.g-user-menu-profile').hasClass("g-user-menu-hide")) {
                
                $('#user-menu-state').removeClass("icon-arrowdown");
                $('#user-menu-state').addClass("icon-arrowup");
                
                return $('.g-user-menu-profile').removeClass("g-user-menu-hide");
            } else {
                
                $('#user-menu-state').removeClass("icon-arrowup");
                $('#user-menu-state').addClass("icon-arrowdown");
                
                return $('.g-user-menu-profile').addClass("g-user-menu-hide");
            }
        });
    }
}


// for accordion/collapse style NAV
export function collapseNav() {
    var directive = {
        restrict: 'A',
        priority: 100,
        link: link
    };

    return directive;

    function link(scope, ele, attrs) {

        'ngInject';

        var $a, $aRest, $app, $lists, $listsRest, $nav, $window, Timer, prevWidth, slideTime, updateClass;

        slideTime = 250;

        $window = $(window);
        if (!scope.item.subitems) return;

        if(scope.item.subitems.length > 0) {

            $lists = ele.find('ul').parent('li');
            $lists.append('<i class="ti-angle-down icon-has-ul-h"></i><i class="ti-angle-right icon-has-ul"></i>');

            $a = $lists.children('a');
            $listsRest = ele.children('li').not($lists);
            $aRest = $listsRest.children('a');
            
            $app = $('#app');
            $nav = $('#nav-container');

            $a.on('click', function(event) {
                var $parent, $this;
                if ($app.hasClass('nav-collapsed-min') || ($nav.hasClass('nav-horizontal') && $window.width() >= 768)) {
                    return false;
                }
                $this = $(this);
                $parent = $this.parent('li');
                $lists.not($parent).removeClass('open').find('ul').slideUp(slideTime);
                $parent.toggleClass('open').find('ul').stop().slideToggle(slideTime);
                event.preventDefault();
            });

            $aRest.on('click', function(event) {
                $lists.removeClass('open').find('ul').slideUp(slideTime);
            });

            scope.$on('nav:reset', function(event) {
                $lists.removeClass('open').find('ul').slideUp(slideTime);
            });

            Timer = void 0;

            prevWidth = $window.width();

            updateClass = function() {
                var currentWidth;
                currentWidth = $window.width();
                if (currentWidth < 768) {
                    $app.removeClass('nav-collapsed-min');
                }
                if (prevWidth < 768 && currentWidth >= 768 && $nav.hasClass('nav-horizontal')) {
                    $lists.removeClass('open').find('ul').slideUp(slideTime);
                }
                prevWidth = currentWidth;
            };

            $window.resize(function() {
                var t;
                clearTimeout(t);
                t = setTimeout(updateClass, 300);
            });
        }
    }
}

export function removeOffCanvas() {
    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, ele, attrs) {
        ele.on('click', function () {
            if ($('#app').hasClass("on-canvas")) {
                return $('#app').removeClass("on-canvas");
            }
        });
    }
}
